import PaymentRepository from "./PaymentRepository";
import { fieldErrorsBackToFront } from "./../misc/dataConversion";
import { AUTH_ACTIONS } from "../auth/authActions";
import { push as pushLocation } from "react-router-redux";
import { backToFront } from "../accts/dataConversion";
import MiscRepository from "assets/scripts/domain/misc/MiscRepository";
export const PAYMENT_ACTIONS = {
    PAYMENT_CREATE_STARTED: "payment-create-started",
    PAYMENT_CREATE_FAILED: "payment-create-failed",
    PAYMENT_CREATE_SUCCEEDED_FALSE: "payment-create-succeeded-false",
    PAYMENT_CREATE_SUCCEEDED_TRUE: "payment-create-succeeded-true",
    RECEIPT_LOAD_STARTED: "receipt-load-started",
    RECEIPT_LOAD_FAILED: "receipt-load-failed",
    RECEIPT_LOAD_SUCCEEDED: "receipt-load-succeeded-true",
    RECEIPT_EMAIL_STARTED: "receipt-email-started",
    RECEIPT_EMAIL_FAILED: "receipt-email-failed",
    RECEIPT_EMAIL_SUCCEEDED: "receipt-email-succeeded-true",
    CANCEL_PAYMENT_STARTED: "cancel-payment-started",
    CANCEL_PAYMENT_FAILED: "cancel-payment-failed",
    CANCEL_PAYMENT_SUCCEEDED: "cancel-payment-succeeded-true",
    AGREED_CHANGE: "agreed-change"
};
function logoutCheck(dispatch, error) {
    if (error && error.response && error.response.status === 401) {
        dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
        dispatch(pushLocation("/public"));
    }
}
export const createPayment = (payment) => async (dispatch) => {
    dispatch({ type: PAYMENT_ACTIONS.PAYMENT_CREATE_STARTED });
    let paymentResponse;
    try {
        paymentResponse = await PaymentRepository.createPayment(payment);
    }
    catch (error) {
        dispatch({ type: PAYMENT_ACTIONS.PAYMENT_CREATE_FAILED, payload: error });
        logoutCheck(dispatch, error);
        return;
    }
    if (!paymentResponse.success) {
        const preparedErrors = fieldErrorsBackToFront(paymentResponse.errors);
        dispatch({
            type: PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_FALSE,
            payload: preparedErrors
        });
    }
    else {
        const { data } = paymentResponse;
        dispatch({
            type: PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_TRUE,
            payload: {
                success: paymentResponse.success,
                data: {
                    ...data,
                    accounts: backToFront(data)
                }
            }
        });
        if (data.type === "Success") {
            dispatch(pushLocation(`/secured/receipt/${data.paymentId}`));
            MiscRepository.trackEvent({
                event: "PaymentComplete",
                payableId: payment.payableId.toString()
            });
        }
    }
};
export const loadReceipt = (id) => async (dispatch) => {
    dispatch({
        type: PAYMENT_ACTIONS.RECEIPT_LOAD_STARTED,
        payload: id
    });
    try {
        const data = await PaymentRepository.loadReceipt(id);
        if (!data.success) {
            throw new Error("Unexpected response");
        }
        dispatch({
            type: PAYMENT_ACTIONS.RECEIPT_LOAD_SUCCEEDED,
            payload: data.data
        });
    }
    catch (error) {
        dispatch({
            type: PAYMENT_ACTIONS.RECEIPT_LOAD_FAILED,
            payload: {
                id,
                error
            }
        });
        logoutCheck(dispatch, error);
    }
};
export const sendReceiptEmail = (id) => async (dispatch) => {
    dispatch({
        type: PAYMENT_ACTIONS.RECEIPT_EMAIL_STARTED,
        payload: id
    });
    try {
        const data = await PaymentRepository.emailReceipt(id);
        if (!data.success) {
            throw new Error("Unexpected response");
        }
        dispatch({
            type: PAYMENT_ACTIONS.RECEIPT_EMAIL_SUCCEEDED,
            payload: data.data
        });
    }
    catch (error) {
        dispatch({
            type: PAYMENT_ACTIONS.RECEIPT_EMAIL_FAILED,
            payload: {
                id,
                error
            }
        });
        logoutCheck(dispatch, error);
    }
};
export const cancelPayment = (id) => async (dispatch) => {
    dispatch({
        type: PAYMENT_ACTIONS.CANCEL_PAYMENT_STARTED,
        payload: {
            id
        }
    });
    try {
        const { data } = await PaymentRepository.cancelPayment(id);
        if (!data.success) {
            throw new Error("Unexpected response");
        }
        dispatch({
            type: PAYMENT_ACTIONS.CANCEL_PAYMENT_SUCCEEDED,
            payload: {
                id,
                accts: backToFront({
                    accounts: data.data
                })
            }
        });
    }
    catch (error) {
        dispatch({
            type: PAYMENT_ACTIONS.CANCEL_PAYMENT_FAILED,
            payload: {
                id,
                error
            }
        });
        logoutCheck(dispatch, error);
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/payment/paymentActions.ts